<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M2.5 12.5 21 4l-7.5 16.5-2-7.5-9-.5z" />
  </svg>
</template>

<script>
export default {
  name: 'IconSendPlaneAlt',
  props: { size: { type: [String, Number], default: 14 } },
};
</script>
